import { post, del, get } from './generic.api';
import { format } from 'date-fns';

export const getAnalyticalReportData = async (clientId, page = 1, pageSize = 10) => {
  try {
    const query = `?client=${clientId}&page=${page}&page_size=${pageSize}&pdf_file=true`;
    const response = await get(`/analytical-report-data/${query}`);
    return response;
  } catch (error) {
    console.error('Erro ao carregar mensagens do analítico:', error.response || error.message);
    throw error;
  }
};

export const PostAnalyticalReportData = async (clientId, startDate, endDate, categoryIds = [], Validationkeyword, subject, swot, qualitative, mention) => {
  try {
        console.log("Dentro de PostAnalyticalReportData - payload:");
        const formattedStartDate = format(new Date(startDate), 'dd/MM/yyyy');
        const formattedEndDate = format(new Date(endDate), 'dd/MM/yyyy');

        const payload = {
            client: clientId,
            date_start: formattedStartDate,
            date_end: formattedEndDate,
            text: Validationkeyword || "",
            subject: subject || "",
            swot: swot || "",
            qualitative: qualitative || "",
            mention: mention || "",
        };

        if (categoryIds.length === 1) {
            payload.category = categoryIds[0];
        } else if (categoryIds.length > 1) {
            payload.categories = categoryIds;
        }

        const response = await post('/analytical-report-data/', payload);
        return response;
  } catch (error) {
    console.error('Erro ao gerar relatório:', error?.response?.data || error?.message || error);
    throw error;
  }
};

export const getAnalyticalReportDataDetails = async (clippingId) => {
  try {
    const query = `${clippingId}`;
    const response = await get(`/analytical-report-data/${query}`);
    return response;
  } catch (error) {
    console.error('Erro ao carregar mensagens do analítico:', error.response || error.message);
    throw error;
  }
};

export const patchAnalyticalReportData = async (clippingId, name, pdfFile) => {
  try {
    const formData = new FormData();
    formData.append('name', name);
    formData.append('pdf_file', pdfFile);

    const response = await post(`/analytical-report-data/${clippingId}/save-pdf/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response;
  } catch (error) {
    console.error('Erro ao salvar PDF do relatório analítico:', error?.response?.data || error?.message || error);
    throw error;
  }
};

export const deleteAnalyticalReportDataDetails = async (clippingId) => {
  try {
    const query = `${clippingId}`;
    const response = await del(`/analytical-report-data/${query}`);
    return response;
  } catch (error) {
    console.error('Erro ao deletar relatório:', error.response || error.message);
    throw error;
  }
};

export const postAnalyticalReportDataByClippingIds = async (clientId, clippingIds = []) => {
  try {
    const payload = {
      client: clientId,
      clipping_ids: clippingIds.join(','),
    };

    const response = await post('/analytical-report-data/', payload);
    return response;
  } catch (error) {
    console.error('Erro ao gerar relatório com clipping_ids:', error?.response?.data || error?.message || error);
    throw error;
  }
};